import { ShoppingCart, Gift } from "lucide-react";
import { cn } from "@/lib/utils";
import type { OrderType } from "@cold-crew/shared";

const TYPE_CONFIG: Record<OrderType, {
  label:     string;
  className: string;
  Icon:      React.ElementType;
}> = {
  venta: {
    label:     "Venta",
    className: "bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-400",
    Icon:      ShoppingCart,
  },
  regalo: {
    label:     "Regalo",
    className: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
    Icon:      Gift,
  },
};

interface OrderTypeBadgeProps {
  tipo: OrderType;
  className?: string;
  /** Show icon alongside label (default: true) */
  showIcon?: boolean;
}

export function OrderTypeBadge({ tipo, className, showIcon = true }: OrderTypeBadgeProps) {
  const cfg = TYPE_CONFIG[tipo];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium",
        cfg.className,
        className
      )}
    >
      {showIcon && <cfg.Icon className="size-3" strokeWidth={2} />}
      {cfg.label}
    </span>
  );
}
